import React from 'react';
import '../styles/Home/Home.css'; // Import the CSS that contains the WhatsApp styles

const Whatsapp = () => {
  return (
    <a href="https://wa.me/918799982010" className="travelscape-whatsapp-float" target="_blank" rel="noopener noreferrer">
      <i className="fab fa-whatsapp"></i>
    </a>
  );
};

export default Whatsapp;
